type WithoutTypename<T> = {
  [P in keyof T as Exclude<P, '__typename'>]: T[P] extends Array<infer U>
    ? Array<WithoutTypename<U>>
    : T[P] extends object
    ? WithoutTypename<T[P]>
    : T[P];
};

export function removeProperties<T>(
  value: T,
  propertiesToRemove: string[] = ['__typename']
): WithoutTypename<T> {
  if (Array.isArray(value)) {
    return value.map((item) =>
      removeProperties(item, propertiesToRemove)
    ) as WithoutTypename<T>;
  }
  if (value && typeof value === 'object') {
    const newObj: WithoutTypename<T> = {} as WithoutTypename<T>;
    for (const item of Object.entries(value)) {
      const [key, val] = item;
      if (!propertiesToRemove.includes(key)) {
        newObj[key] = removeProperties(val, propertiesToRemove);
      }
    }
    return newObj;
  }
  return value as WithoutTypename<T>;
}
